<template>
  <div class="standard-page">
    <AuthOverlay>
      <template #header>
        <GradientHeading>Login</GradientHeading>
      </template>

      <b-form @submit.prevent="handleSubmit" class="text-center">
        <b-form-group>
          <b-form-input v-model="email" placeholder="Email" />
        </b-form-group>

        <b-form-group>
          <b-form-input
            v-model="password"
            type="password"
            placeholder="Password"
          />
        </b-form-group>

        <b-button pill variant="outline-primary" type="submit">
          Login
        </b-button>

        <div class="errors">
          <div v-for="error in errorList" :key="error" class="error">
            {{ error }}
          </div>
        </div>
      </b-form>
    </AuthOverlay>
  </div>
</template>

<script>
import AuthOverlay from '@/components/Authentication/AuthOverlay/AuthOverlay.vue'
import GradientHeading from '@/components/Elements/GradientHeading/GradientHeading.vue'

export default {
  components: { AuthOverlay, GradientHeading },
  data() {
    return {
      email: '',
      password: '',
      errors: {}
    }
  },
  methods: {
    handleSubmit() {
      this.errors = {}
      const credentials = { email: this.email, password: this.password }
      this.$store
        .dispatch('login', credentials)
        .then(res => {
          Promise.all([
            this.$store.dispatch('getProfile'),
            this.$store.dispatch('getMerchantCount'),
            this.$store.dispatch('getMerchant', { merchantID: null })
          ]).then(res => {
            this.$nextTick(() => {
              if (this.$store.getters.profile.organization.in_legacy_app) {
                this.$router.push({ name: 'TransactionSearch' })
              } else {
                this.$router.push(
                  this.$route.query.next || {
                    name: 'Home'
                  }
                )
              }
            })
          })
        })
        .catch(err => {
          if (err?.response?.data) {
            console.log('error.response.data', err.response.data)
            this.errors = err.response.data
          } else {
            console.log('unknown error', err)
          }
        })
    }
  },
  computed: {
    errorList() {
      return Object.entries(this.errors).map(([key, value]) => {
        if (Array.isArray(value)) {
          return `${key}: ${value[0]}`
        } else {
          return value
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.errors {
  margin-top: 20px;
  color: $danger;
}

.error {
  &:first-letter {
    text-transform: capitalize;
  }
}
</style>
